import classNames from 'classnames';
import React from 'react';

import styles from '../../styles.module.scss';

type StatsGaugeProps = {
  moviesCount: number;
  seriesCount: number;
  moviesBarClassname?: string;
  seriesBarClassname?: string;
};

/**
 * StatsGauge component
 * Displays the number of movies and series watched as a visual gauge
 */
const StatsGauge = ({
  moviesCount,
  seriesCount,
  moviesBarClassname,
  seriesBarClassname
}: StatsGaugeProps) => {
  const movieLabel = moviesCount > 1 ? 'films' : 'film';
  const seriesLabel = seriesCount > 1 ? 'séries' : 'série';

  return (
    <div className={styles.statsGauge}>
      <div className={classNames(styles.statsGaugeCol, styles.movieCol)}>
        <div className={styles.statsGaugeTicket}>
          <div className={styles.ticketCount}>{moviesCount}</div>
          <div className={styles.ticketText}>{movieLabel}</div>
        </div>
        <div className={styles.statsBarTotal}>
          <div
            className={classNames(styles.statsBarValue, moviesBarClassname)}
          ></div>
        </div>
      </div>
      <div className={classNames(styles.statsGaugeCol, styles.seriesCol)}>
        <div className={styles.statsGaugeTicket}>
          <div className={styles.ticketCount}>{seriesCount}</div>
          <div className={styles.ticketText}>{seriesLabel}</div>
        </div>
        <div className={styles.statsBarTotal}>
          <div
            className={classNames(styles.statsBarValue, seriesBarClassname)}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default StatsGauge;
